import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "../../mocks/news";

const SUBSCRIBE_URL = "https://readdy.ai/api/form/dagn2chtto0ceqqni0gg";

export default function SiteFooter() {
  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get("company_alt") as string) || "").trim();
    setStatus("idle");
    setMsg("");

    const showSuccess = () => {
      setStatus("ok");
      setMsg("已收到，感谢订阅！我们会第一时间把最新独家热点发到你的邮箱。");
      form.reset();
    };
    const showError = (text: string) => {
      setStatus("err");
      setMsg(text);
    };

    if (honeypot) {
      showSuccess();
      return;
    }
    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key !== "company_alt" && value) payload.append(key, String(value));
    });

    try {
      const res = await fetch(SUBSCRIBE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        /* ignore */
      }
      const serverMsg =
        (parsed?.meta as Record<string, unknown>)?.message ||
        (parsed as Record<string, unknown>)?.message ||
        (parsed?.meta as Record<string, unknown>)?.detail ||
        "";
      if (res.ok && (parsed as Record<string, unknown>)?.code === "OK") {
        showSuccess();
      } else {
        showError(typeof serverMsg === "string" && serverMsg ? serverMsg : "订阅失败，请稍后再试。");
      }
    } catch {
      showError("网络异常，请稍后再试。");
    }
  };

  return (
    <footer className="mt-16 bg-secondary-800 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-400 font-serif text-xl font-black text-secondary-900">
                爆
              </span>
              <span className="font-serif text-2xl font-black tracking-tight text-background-50">
                每日爆料<span className="text-accent-300">网</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              专注娱乐圈与网红圈独家热点与首发追踪，以客观、有料、不失速的编辑视角，陪你第一时间看清台前幕后。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <Link
                to="/about"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-700 text-background-50 transition-colors hover:bg-accent-400 hover:text-secondary-900"
                aria-label="关于我们"
              >
                <i className="ri-information-line" />
              </Link>
              <Link
                to="/faq#contact"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-700 text-background-50 transition-colors hover:bg-accent-400 hover:text-secondary-900"
                aria-label="联系我们"
              >
                <i className="ri-mail-line" />
              </Link>
              <Link
                to="/faq#tougao"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-700 text-background-50 transition-colors hover:bg-accent-400 hover:text-secondary-900"
                aria-label="线索投稿"
              >
                <i className="ri-megaphone-line" />
              </Link>
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h3 className="font-serif text-base font-bold text-background-50">浏览栏目</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="inline-flex items-center gap-2 transition-colors hover:text-accent-300">
                    <i className="ri-corner-down-right-line text-xs opacity-60" />
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/" className="inline-flex items-center gap-2 transition-colors hover:text-accent-300">
                  <i className="ri-corner-down-right-line text-xs opacity-60" />
                  首页头条
                </Link>
              </li>
            </ul>
          </div>

          {/* 关于本站 */}
          <div>
            <h3 className="font-serif text-base font-bold text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-300">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about#fazhan" className="transition-colors hover:text-accent-300">发展理念</Link>
              </li>
              <li>
                <Link to="/about#yuanze" className="transition-colors hover:text-accent-300">内容原则</Link>
              </li>
              <li>
                <Link to="/faq" className="transition-colors hover:text-accent-300">常见问题</Link>
              </li>
            </ul>
          </div>

          {/* 订阅 */}
          <div>
            <h3 className="font-serif text-base font-bold text-background-50">第一时间获取猛料</h3>
            <p className="mt-4 text-sm text-background-200">留下邮箱，不错过每日首发与独家追踪更新。</p>
            <form onSubmit={onSubmit} data-readdy-form className="mt-4 max-w-xs">
              <input
                type="email"
                name="email"
                required
                placeholder="你的邮箱地址"
                className="w-full rounded-md border border-secondary-700 bg-secondary-700/60 px-3 py-2 text-sm text-background-50 outline-none transition-colors placeholder:text-background-300 focus:border-accent-300"
              />
              <input
                type="text"
                name="company_alt"
                aria-hidden="true"
                tabIndex={-1}
                autoComplete="off"
                readOnly
                className="field-guard"
              />
              <button
                type="submit"
                className="mt-2 w-full cursor-pointer whitespace-nowrap rounded-md bg-accent-400 px-4 py-2 text-sm font-medium text-secondary-900 transition-colors hover:bg-accent-300"
              >
                立即订阅
              </button>
              {status === "ok" && (
                <p className="mt-2 rounded-md bg-accent-400/10 px-3 py-2 text-xs leading-relaxed text-accent-200">{msg}</p>
              )}
              {status === "err" && (
                <p className="mt-2 rounded-md bg-primary-400/10 px-3 py-2 text-xs leading-relaxed text-primary-100">{msg}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-700/60 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© 2026 每日爆料网 · 本站为泛娱乐资讯内容站点</p>
          <p className="flex items-center gap-1">
            <i className="ri-shield-check-line" /> 坚持客观报道，尊重事实与隐私
          </p>
        </div>
      </div>
    </footer>
  );
}